export default "__VITE_ASSET__0ec9d08e__"